export const cloudConnect = require('./cloudConnect.jpeg');
export const kanbanTeamwork = require('./kanbanTeamwork.jpeg')
export const kanbanWorkflow = require('./kanbanWorkflow.jpeg');
export const patternOfPeople = require('./patternOfPeople.jpeg');
export const programConfiguring = require('./programConfiguring.jpeg')
export const smallBoard = require('./smallBoard.jpeg')
export const timeline = require('./timeline.jpeg')
export const workflowOrganization = require('./workflowOrganization.jpeg')